document.addEventListener("DOMContentLoaded", function() {
    const searchInput = document.getElementById("predictive-search");
    const searchResults = document.getElementById("search-results");

    searchInput.addEventListener("input", function() {
        const query = searchInput.value;

        if (query.length < 3) {
            searchResults.innerHTML = "";
            return;
        }

        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`)
            .then(response => response.json())
            .then(data => {
                const products = data.resources.results.products;
                let resultsHTML = "";

                products.forEach(product => {
                    resultsHTML += `
                        <a href="${product.url}">
                            <div class="result-item">
                                <img src="${product.image}" alt="${product.title}" width="40" height="40">
                                <span>${product.title}</span>
                            </div>
                        </a>
                    `;
                });

                searchResults.innerHTML = resultsHTML;
            })
            .catch(error => {
                console.error("Error fetching predictive search results:", error);
            });
    });
});
